import type { InputRef } from 'antd';
import { useEffect, useRef } from 'react';

const useAutoFocusInput = (open: boolean) => {
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100); // Delay ensures modal is fully opened
    }
  }, [open]);

  return inputRef;
};

export default useAutoFocusInput;
